<template>
	<div v-if="!(ptInitData.productInfo.FORM_LP_FLG == 1 && isLp)">
		<div class="likeContainer sort-item">
			<!-- お気に入りに追加 -->
			<input class="likeBtn" type="button"
				v-if="ptInitData.loginKbn == true && (getLengthObj(ptInitData.favoritesList) == 0 || ptInitData.favoritesList == undefined || ptInitData.favoritesList == null || ptInitData.favoritesList == '')"
				@click="pt125favorites();"
				:value="$t('pt125.labels.add2Favourite')">
		</div>
		<div class="likeRemoveContainer sort-item">
			<!-- お気に入り解除 -->
			<input class="likeBtn" type="button"
				v-if="ptInitData.loginKbn == true && getLengthObj(ptInitData.favoritesList) > 0"
				@click="pt125removeFavorites();"
				:value="$t('pt110.labels.deleteFavourite')">
		</div>
	</div>
</template>
<script>
import common from "assets/js/common";
export default {
	name: 'likeContainer',
	props: {
		ptInitData: {
			type: Object,
			default: null
		},
		isLp: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		pt125favorites: function () {
			this.$emit('pt125favorites');
		},
		pt125removeFavorites: function () {
			this.$emit('pt125removeFavorites');
		},
		/**
	 * get length a object
	 * @param {Object} obj, object to get length
	 */
		getLengthObj: function (obj) {
			if (obj != undefined)
				return common.getLengthObj(obj);
		},
	}
}
</script>